export default __webpack_public_path__ + "media/images/icons_fc/tools2-82e2b23c84d2bac64c038aa32f114984.png";